import { CalendarDays, ClipboardList, FileText, Inbox, LayoutDashboard, Receipt, Smartphone, Sparkles, TabletSmartphone, Users } from "lucide-react";

/* Sidebar sections for the Drift shell. Shared with the command menu. */
export const NAV_SECTIONS = [
  {
    label: "Arbeid",
    items: [
      { to: "/drift", label: "Oversikt", icon: LayoutDashboard, end: true, testid: "oversikt" },
      { to: "/drift/ai", label: "Assistent", icon: Sparkles, testid: "ai", also: ["/drift/ai"] },
      { to: "/drift/henvendingar", label: "Henvendingar", icon: Inbox, badge: "inquiries", testid: "henvendingar" },
      { to: "/drift/oppdrag", label: "Oppdrag", icon: ClipboardList, testid: "oppdrag" },
      { to: "/drift/planlegging", label: "Planlegging", icon: CalendarDays, testid: "planlegging" },
    ],
  },
  {
    label: "Kundar",
    items: [{ to: "/drift/kundar", label: "Kundar og anlegg", icon: Users, testid: "kundar", also: ["/drift/anlegg"] }],
  },
  {
    label: "Økonomi",
    items: [
      { to: "/drift/tilbod", label: "Tilbod", icon: FileText, badge: "quotes", testid: "tilbod" },
      { to: "/drift/fakturagrunnlag", label: "Fakturagrunnlag", icon: Receipt, badge: "invoice", testid: "fakturagrunnlag" },
    ],
  },
  {
    label: "Felt",
    items: [
      { to: "/drift/felt", label: "Feltvising", icon: Smartphone, testid: "felt" },
      { to: "/drift/montor", label: "Montørvisning", icon: TabletSmartphone, testid: "montor" },
    ],
  },
];
export const NAV = NAV_SECTIONS.flatMap((s) => s.items);
